module.exports = __webpack_public_path__ + "img/wideawake1.a13973ea.png";